const CREDIT_COST_BY_PROJECT = {
  Interview: 1,
  Survey: 0.25,
};

export default CREDIT_COST_BY_PROJECT;
